<template>
   <a
      title="tos-link"
      :href="
         locale === 'de'
            ? 'https://www.iubenda.com/terms-and-conditions/43651813'
            : locale === 'it'
              ? 'https://www.iubenda.com/terms-and-conditions/64527126'
              : 'https://www.iubenda.com/terms-and-conditions/95967575'
      "
      class="iubenda-nostyle iubenda-noiframe iubenda-embed iub-body-embed"
   />
</template>

<script lang="ts" setup>
const { locale } = useI18n()

onBeforeMount(() => {
   let s = document.createElement('script')
   let tag = document.getElementsByTagName('script')[0]
   s.src = 'https://cdn.iubenda.com/iubenda.js'
   tag?.parentNode?.insertBefore(s, tag)
})
</script>

<style>
#iub-legalDoc {
   --green: var(--color-primary) !important;
   --green-dark: var(--color-primary) !important;
   --green-light: var(--color-secondary) !important;
   --legal-gray: var(--color-light-grey) !important;
   --black-light: var(--color-grey) !important;
}
</style>
